@if (isVisible()) {
  <xi-generic-modal
    [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
    [isVisible]="isVisible()"
    [allowScroll]="allowScroll()"
    [canBackdropClose]="canBackdropClose()"
    [allowPropagation]="allowPropagation()"
    [maxWidth]="maxWidth()"
    [targetElement]="targetElement"
    (onClose)="onClose()"
  >
    <div slot="children" class="lex-xi-modal__content-wrapper">
      <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container>
    </div>
  </xi-generic-modal>
}
